import { render, staticRenderFns } from "./PannelEight.vue?vue&type=template&id=1bce22c8&scoped=true&"
import script from "./PannelEight.vue?vue&type=script&lang=js&"
export * from "./PannelEight.vue?vue&type=script&lang=js&"
import style0 from "./PannelEight.vue?vue&type=style&index=0&id=1bce22c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce22c8",
  null
  
)

export default component.exports